<div class="bar-container" [ngClass]="{ linear }" (click)="goToBlackFriday()">
  <div class="bar">
    <div class="context-container">
      <ng-container *ngFor="let _ of contextLength">
        <ng-container *ngTemplateOutlet="firstContext"></ng-container>
      </ng-container>
    </div>
  </div>

  <div class="bar black">
    <div class="context-container">
      <ng-container *ngFor="let _ of contextLength">
        <ng-container *ngTemplateOutlet="secondContext"></ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #firstContext>
  <div class="text">Exclusive Discount</div>
  <div class="text dot">.</div>
  <div class="text outlined">Exclusive Discount</div>
  <div class="text dot">.</div>
</ng-template>

<ng-template #secondContext>
  <div class="text">Black Friday</div>
  <div class="text dot">.</div>
  <div class="text outlined">Black Friday</div>
  <div class="text dot">.</div>
</ng-template>
